import { useState } from "react";
import AppModal from "./AppModal";
import { authService } from "../services/apiService";
import { showToast } from "../utils/toast";
import { validateForm } from "../utils/validate";

export default function ChangePasswordModal({ open, onClose }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const reset = () => {
    setCurrent("");
    setNext("");
    setConfirm("");
    setError("");
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  const save = async (e) => {
    e.preventDefault();
    setError("");
    if (
      !validateForm(e.currentTarget, [
        { name: "current", value: current, label: "Current password", required: true },
        { name: "next", value: next, label: "New password", required: true, minLength: 6 },
        { name: "confirm", value: confirm, label: "Confirm password", required: true,
          custom: (v) => (v && v !== next ? "Those passwords don't match" : null) },
      ])
    ) {
      if (next.length >= 6 && next !== confirm) setError("Those passwords don't match.");
      return;
    }

    setBusy(true);
    try {
      const res = await authService.changePassword(current, next);
      if (res?.success) {
        showToast("success", "Password updated");
        handleClose();
      } else {
        setError(res?.msg || "We couldn't update your password.");
      }
    } catch (err) {
      setError(err?.response?.data?.msg || "Something went wrong.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AppModal
      open={open}
      onClose={handleClose}
      title="Change password"
      size="sm"
      footer={
        <>
          <button type="button" className="btn btn-outline-secondary" onClick={handleClose} disabled={busy}>
            Cancel
          </button>
          <button type="submit" form="change-password-form" className="btn btn-primary" disabled={busy}>
            {busy ? "Saving…" : "Update password"}
          </button>
        </>
      }
    >
      {error && <div className="alert alert-danger py-2">{error}</div>}
      <form id="change-password-form" onSubmit={save} noValidate>
        <div className="mb-3">
          <label className="form-label">Current password</label>
          <input
            type="password"
            name="current"
            className="form-control"
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
            autoComplete="current-password"
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">New password</label>
          <input
            type="password"
            name="next"
            className="form-control"
            value={next}
            onChange={(e) => setNext(e.target.value)}
            placeholder="At least 6 characters"
            autoComplete="new-password"
            required
            minLength={6}
          />
        </div>
        <div className="mb-0">
          <label className="form-label">Confirm new password</label>
          <input
            type="password"
            name="confirm"
            className="form-control"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            placeholder="Re-enter new password"
            autoComplete="new-password"
            required
          />
        </div>
      </form>
    </AppModal>
  );
}
